import React from "react";
import { Text } from "tamagui";

/*******************************************************************
 * Type: 自定義文本組件
 * Description:
 *     1. 顯示自定義樣式的文本，支持多種字體大小和樣式
 *     2. 可用於應用程序中的各種文本顯示需求
 * Params:
 *     - str: 要顯示的文本，必填
 *     - type: 字體大小，必填，使用 TextSize 枚舉定義
 *     - textCenter: 是否將文本居中顯示，默認為 false（可選）
 *     - color: 文本顏色，默認為黑色（可選）
 *     - bold: 是否加粗文本，默認為 false（可選）
 *     - italic: 是否使用斜體字，默認為 false（可選）
 *     - underline: 是否添加下劃線，默認為 false（可選）
 *     - strikeThrough: 是否添加刪除線，默認為 false（可選）
 *     - others: 其他自定義屬性，以便傳遞給底層的 Text 組件（可選）
 *     - align: 文本對齊方式，默認為 "center"（可選）
 *     - mx: 水平邊距，可以是數字或字符串（可選）
 *     - my: 垂直邊距，可以是數字或字符串（可選）
 ******************************************************************/

// 定義不同類型的字體大小
export enum TextSize {
  TITLE = "$11",
  SUBTITLE = 35,
  HEADING = 30,
  SUBHEADING = 28,
  LARGER = 26,
  LARGE = 25,
  SEMI_LARGE = 23,
  SUBLARGE = 22,
  MEDIUM = 20,
  NORMAL = 18,
  SUBNORMAL = 17,
  SMALL = 16,
  SUBSMALL = 15,
  EXTRA_SMALL = 14,
  TINY = 12,
  SUBTINY = 10,
  MICRO = 8,
}

// 定義TextProps接口
interface TextProps {
  str: string;
  type: TextSize;
  textCenter?: boolean;
  color?: string;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  strikeThrough?: boolean;
  others?: any;
  align?: string;
  mx?: number | string;
  my?: number | string;
}

const TextCustom: React.FC<TextProps> = ({
  str,
  type,
  textCenter = false,
  color = "#000",
  bold = false,
  italic = false,
  underline = false,
  strikeThrough = false,
  others,
  align = "center",
  mx,
  my,
}) => {
  const fontSize = type;
  return (
    <Text
      alignSelf={textCenter ? "center" : "none"}
      textAlign={align}
      fontSize={fontSize}
      color={color}
      style={{
        fontWeight: bold ? 900 : 400,
        fontStyle: italic ? "italic" : "unset",
        textDecoration: underline ? "underline" : strikeThrough ? "strikeThrough" : "unset",
      }}
      mx={mx}
      my={my}
      {...others}>
      {str}
    </Text>
  );
};

export default TextCustom;
